
import Vue from 'vue';
import CloseIcon from '@/components/icons/CloseIcon.vue';

export default Vue.extend({
    name: 'RotateTooltip',
    components: { CloseIcon },
    props: {
        initTooltip: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            isTooltipOpen: true,
        };
    },
    methods: {
        closeTooltip(event: MouseEvent | TouchEvent) {
            if (!event.target) return;
            const target = event.target as HTMLElement;
            if (!target.classList.contains('psv-markers-svg-container')) return;
            this.isTooltipOpen = false;
        },
        closeTooltipFromClick() {
            this.isTooltipOpen = false;
        },
    },
    created() {
        document.addEventListener('mousedown', this.closeTooltip);
        document.addEventListener('touchstart', this.closeTooltip);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.closeTooltip);
        document.removeEventListener('touchstart', this.closeTooltip);
    },
});
